import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import SummitImg from "../../images/about/img-1.webp";
import EarlyBirdBonuses from "../../components/EarlyBirdBonuses/EarlyBirdBonuses";
import SummitHighlight from "../../components/SummitHighlight/SummitHighlight";
import SummitObjectivesNew from "../../components/SummitObjectives/SummitObjectivesNew";

const VideoSection = () => {
  return (
    <section className="video-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="video-section-content text-center">
              <h2 className="video-heading">Join the cash flow revolution!</h2>
              <div className="video-wrapper">
                <div className="video-container">
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/ecJIhX7ScEU"
                    title="Join the cash flow revolution!"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const AboutSummitSection = () => {
  return (
    <section className="about-summit-section section-padding">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side - Image */}
          <div className="col-xl-6 col-12">
            <div className="summit-left-content">
              <div className="image">
                <img src={SummitImg} alt="The Cash Flow Summit 2026" />
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="col-xl-6 col-12">
            <div className="summit-right-content">
              <div className="info-tag">
                <span className="info-icon">
                  <i className="fa fa-info-circle"></i>
                </span>
                About The Summit
              </div>

              <h2 className="main-heading">
                Master Cash Flow Control & Achieve Financial Freedom
              </h2>

              <p className="description">
                The Cash Flow Summit 2026 is a one-day mega event designed to
                help entrepreneurs, business owners, and professionals master
                the art of cash flow control, financial freedom, and long-term
                stability.
              </p>

              <ul className="summit-details">
                <li>
                  <i className="fa fa-check-circle"></i>
                  Led by CA Jagmohan Singh, India's leading Cash Flow Expert
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  One-day mega event on 11th April 2026
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  At Talkatora Stadium, New Delhi
                </li>
                <li>
                  <i className="fa fa-check-circle"></i>
                  10,000+ Expected Participants
                </li>
              </ul>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const AboutPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>
          India’s No.1 Cash Flow Expert | Cash Flow Revolution &amp; Mastery
        </title>
        <meta
          name="description"
          content=" Attend Cash Flow Revolution &amp; Mastery by Jagmohan Singh, India’s No.1 Cash Flow Expert, and discover practical strategies to improve cash flow, grow income streams, and achieve financial freedom."
        />
        <meta
          name="keywords"
          content="India’s No.1 Cash Flow Expert, Cash Flow Revolution, Cash Flow Mastery"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"About Us"} pagesub={"About"} />
      <VideoSection />
      <AboutSummitSection />
      <SummitHighlight />
      <SummitObjectivesNew />
      <EarlyBirdBonuses />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};
export default AboutPage;
